export type FirmwareModel = {
    id: string;
    createdAt: string;
    modifiedAt: string;
    name: string;
    componentId: string;
    appVersion: string;
    version: string;
    protocolVersion: string;
    configuration: string;
    description: string;
    size: number;
    url: string;
    authorizedRoles: string[];
    authorizedUsers: string[];
    authorizedUserNames?: string[];
    status: boolean;
    isEditMode?: boolean;
    isCreateMode?: boolean;
}

export type OptionModel = {
    id: string;
    type: string;
    values: any;
    isOpen?: boolean; // for expand and collapse
}

export type TuneModel = {
    id: string;
    userId: string;
    createdAt: string;
    modifiedAt: string;
    global: boolean;
    name: string;
    machineName: string;
    protocolVersion: string;
    configuration: string;
    description: string;
    componentId: string;
    data: string;
    authorizedRoles: string[];
    authorizedUsers: string[];
    authorizedUserNames?: string[];
    status: boolean;
    isEditMode?: boolean;
    isCreateMode?: boolean;
}

export type UserModel = {
    id: string;
    role: string;
    email: string;
    firstName: string;
    lastName: string;
    name: string;
    phone: string;
    riderType: string;
    location: string;
}

export type TableColumn = {
    id: string;
    label: string;
    minWidth?: number;
    align: any;
    format?: (value: any) => string;
}

export interface IBaseApi {
    get<T>(url: string, customHeaders?: any): Promise<T>;
    post<T, R>(url: string, body: T, customHeaders?: any): Promise<R>;
    put<T>(url: string, body: T, customHeaders?: any): Promise<T>;
    delete(url: string, customHeaders?: any): Promise<void>;
}

export enum FormMode {
    Create = 'create',
    Edit = 'edit',
}

export enum Role {
    Admin = 'admin',
    Affiliate = 'affiliate',
    Customer = 'customer'
}

export type ServerError = {
    status: number;
    source: string;
    detail: string;
}

export enum Variant {
    text = 'text',
    outlined = 'outlined',
    contained = 'contained',
}

export enum TuneFilters {
    onlyMyTunes = 'onlyMyTunes',
    onlyGlobal = 'onlyGlobal',
    all = 'all',
}
